<template>
	<li class="menu-header">
    <slot></slot>
  </li>
</template>

<script>
	export default {
		name: "e-menu-header"
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/sidebar/menuHeader.vue